module.exports = ".filter-options-wrapper {\n  margin-bottom: 15px; }\n\n.filter-axis {\n  padding: 10px; }\n\n::ng-deep mat-dialog-container {\n  padding: 15px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/filter-radiobutton-popup/filter-radiobutton-popup.component.scss
// module id = ./src/app/components/filter-radiobutton-popup/filter-radiobutton-popup.component.scss
// module chunks = main